




























import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class URegisterPassEditComp extends CheckUserLogin {}
